/**
 * Fire a Plausible custom event.
 * No-ops gracefully if Plausible hasn't loaded (dev, ad blockers, etc.).
 *
 * Usage:
 *   trackEvent('Newsletter Signup');
 *   trackEvent('Contact Click', { location: 'about' });
 */
export const trackEvent = (name, props) => {
  if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
    window.plausible(name, props ? { props } : undefined);
  }
};
